/* eslint-disable import/no-cycle */
import { Suspense, lazy } from "react";
import { CoverProps } from "hardcover-ui/theme/components/cover";
import useMount from "hooks/useMount";

const BookDetailsPopoverButton = lazy(
  () => import("./BookDetailsPopoverButton")
);

interface Props {
  bookId: number;
  referrerId?: number;
  size: CoverProps["size"];
}

export default function BookDetailsPopoverButtonWrapper({
  bookId,
  referrerId,
  size,
}: Props) {
  const mounted = useMount();

  if (!mounted) {
    return <></>;
  }

  return (
    <Suspense>
      <BookDetailsPopoverButton bookId={bookId} size={size} referrerId={referrerId} />
    </Suspense>
  );
}
